import { render, staticRenderFns } from "./editItemLocal.vue?vue&type=template&id=72f4de24&scoped=true&"
import script from "./editItemLocal.vue?vue&type=script&lang=js&"
export * from "./editItemLocal.vue?vue&type=script&lang=js&"
import style0 from "./editItemLocal.vue?vue&type=style&index=0&id=72f4de24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f4de24",
  null
  
)

export default component.exports